// src/interceptors.js
import api from './api';
import axios from 'axios';
import store from '../../store/store.js';
import Constant from '../../../constant.js';

let isRefreshing = false;
let refreshSubscribers = [];

function onRefreshed(token) {
    refreshSubscribers.map(cb => cb(token));
}

function addRefreshSubscriber(callback) {
    refreshSubscribers.push(callback);
}

api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            if (!isRefreshing) {
                isRefreshing = true;

                const refreshToken = localStorage.getItem('refreshToken');

                try {
                    const url = Constant.authApiBaseUrl + '/api/v1/auth/refresh/';
                    const refreshToken = localStorage.getItem('refreshToken');

                    const res = await axios.post(url, {}, {
                        headers: {
                            Authorization: `Bearer ${refreshToken}`
                        }
                    });

                    const newAccessToken = res.data?.token;
                    const newRefreshToken = res.data?.refreshToken;

                    // Save tokens
                    localStorage.setItem('accessToken', newAccessToken);
                    localStorage.setItem('refreshToken', newRefreshToken);

                    // SET Bearer globally
                    api.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;

                    // Optional: commit to Vuex store
                    store.commit('SET_BEARER', newAccessToken);

                    isRefreshing = false;

                    onRefreshed(newAccessToken);
                    refreshSubscribers = [];

                    return api(originalRequest);
                } catch (err) {
                    isRefreshing = false;
                    refreshSubscribers = [];
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                    localStorage.removeItem('userInfo');
                    window.location.href = '/v2login'; // Optional: redirect
                    return Promise.reject(err);
                }
            }

            return new Promise((resolve) => {
                addRefreshSubscriber((token) => {
                    // Update Authorization header directly
                    originalRequest.headers = originalRequest.headers || {};
                    originalRequest.headers['Authorization'] = `Bearer ${token}`;
                    resolve(api(originalRequest));
                });
            });
        }

        return Promise.reject(error);
    }
);
